<script>     
    import * as detectMobileMixin from '../shared/detect-mobile-mixin.vue';
    import vSelect from 'vue-select';
     export default{         
        props:['pagedItems','level','loading', 'total'],
        mixins:[detectMobileMixin],
        data(){
            return {    
                sortby:"- 排序 -",
                notFound:false,                
                logoOK:{}
            };
        },  
        mounted(){
            this.checkNotFoundStatus();
        },        
        created:function(){                                   
        },
        watch:{
            sortby:function(sortby){
                // console.log("sort by on change ", sortby);
                if(sortby != '- 排序 -' && sortby != null){
                    if(sortby == '性別'){
                        sortby = '就讀學生性別';
                    }
                    this.$emit('sortByOnChange', sortby);
                }else if(sortby == null){
                    this.$emit('sortByOnChange', null);
                    this.sortby = "- 排序 -";
                }
            },
            pagedItems:function(pagedItems){
                if(this.level=='幼稚園'){
                    pagedItems.forEach(item=>{
                        if(!this.logoOK.hasOwnProperty(item.中文名稱)){                        
                            this.testItemSrc(item);
                        }                    
                    })
                }
                this.checkNotFoundStatus();          
            }
        },      
        methods:{
            getEBookUrl(item){                
                // console.log(item);
                // console.log("getEBookUrl",);
                let r = _.find(item.files,{'cover_or_book': 'BOOK'});
                if(item.isNew=='N'){                    
                    if(r){
                        return '/ebook/qr/' + item.qr_code;
                    }
                }else if(item.isNew =='Y'){
                     if(item.category == '教育專業'){
                        return  "/ebook/reader/"+ item.qr_code;
                    }else{
                        return  "/ebook/qr/"+ item.qr_code;
                    }                                        
                }
                return "";                
            },
            getEBookImgSrc(item){
                // console.log("getEBookImgSrc",item);

// $src = collect($item['files'])->where('cover_or_book', 'COVER')->first()['images'][0];
//    // dd($src);
//    $download = 'https://media.goodschool.hk' . collect($item['files'])->where('cover_or_book', 'BOOK')->first()['url'];



                if(item.isNew=='N'){   
                    let r = _.find(item.files,{'cover_or_book': 'COVER'});
                    if(r){
                        return mediaRoot + r.url;
                    }
                }else if(item.isNew =='Y'){
                     let r = _.find(item.files,{'cover_or_book': 'COVER'});
                     if(r.images[0]){
                         return r.images[0];
                     }                                           
                }
                return "";                          
            },
            getSchoolLogoName(name){
                let fileName = name.replace(/\s/g,'');
                fileName = fileName.replace("（", "(");
                fileName = fileName.replace("）", ")");                
                return fileName;                   
            },
            getVisitChineseDate(date){
                let d = moment(date, 'YYYY/MM/DD');
                return `${d.format('YYYY')}年${d.format('M')}月`;
            },
            checkNotFoundStatus(){
                if(this.pagedItems){
                    if(this.pagedItems.length == 0 ){    
                        this.notFound = true;
                    }else{
                        this.notFound = false;
                    }                      
                }else{
                    this.notFound = true;
                }
            },
            showDetails(){  
                // console.log("clicked show Details");                              
                this.$emit('showDetails', true);
            },
            schoolDetailPath(item){
                if(!item || !item.中文名稱) return '/';
                const name = item.中文名稱;
                if(this.level === '國際學校' || item.學校類型 === '國際學校'){
                    return '/int/' + encodeURIComponent(name);
                }
                return '/' + name;
            },
            schoolDistrictPath(item){
                if(!item || !item.分區) return '#';
                if(this.level === '國際學校' || item.學校類型 === '國際學校'){
                    return '/int?district=' + encodeURIComponent(item.分區);
                }
                const t = this.getSchoolType(item.學校類型);
                if(!t) return '#';
                return '/district/' + t + '/' + item.分區;
            },
            chunkItems(items){
                 return _.chunk(items,3);
            },
            schoolLinkage(str){
                // console.log(str);
                if(!str)return ``;
                if(str == '-')return ``;
                if(str.indexOf('、')==-1){
                    return `<a href="/${str}">${str}</a>`
                }else{
                    let linkage='';
                    let schools = str.split('、');
                    schools.forEach(s=>{
                        s = s.replace(/\s/g, '');
                        let link = `<a href="/${s}">${s}</a>&nbsp;`;
                        linkage+=link;
                    });
                    return linkage;
                }
            },
            getSchoolType(level){
                if(level.indexOf('幼稚園')>-1){
                    return "kg";
                }else if(level.indexOf('小學')>-1){
                    return "ps";
                }else if(level.indexOf('中學')>-1){
                    return "ss";
                }
            },
            isKg(type){                
                if(type.indexOf('幼稚園')>-1){
                    return true
                }
                return false
            },
            testItemSrc(item){                
                let src='';
                if(item.學校類型=='中學'){
                    src = 'https://media.goodschool.hk/images/slogo/'+ item.中文名稱 + '.jpg';
                }
                if(item.學校類型=='小學'){
                    src = 'https://media.goodschool.hk/images/slogo/'+ item.中文名稱 + '.jpg';
                }
                else{
                    src = 'https://media.goodschool.hk/images/slogo/'+ item.中文名稱 + '.jpg';
                }

                $.ajax({
                    type:'HEAD',
                    url:src,
                    complete:(res)=>{                        
                        if(res.status == 404){                                                                                    
                            Vue.set(this.logoOK,item.中文名稱,false);
                        }else{
                            Vue.set(this.logoOK,item.中文名稱,true);
                        }
                    }
                })          
            }      
        }
    }
    
</script>




// WEBPACK FOOTER //
// resources/js/school/SchoolListViewMixin.vue